module.exports = __webpack_public_path__ + "media/images/icons/icn_025-ffc194a9fc612d3672fc83f347945fef.svg";